import Article from "../../../../utils/models/menu/Article.ts";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import FormattedMessageJamezz from "../../../FormattedMessageJamezz.tsx";

export default function ConfirmMaxRoundItemOrderPopup({
  article,
  onCancel,
  onConfirm,
  roundsItemHasBeenOrdered,
  roundsMaximum,
}: {
  article: Article;
  roundsMaximum: number;
  roundsItemHasBeenOrdered: number;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return (
    <Dialog open={true}>
      <DialogTitle>
        <FormattedMessageJamezz id="AYCE.popups.heading.limited-product" />
      </DialogTitle>
      <DialogContent>
        <span style={{ textDecoration: "underline", fontWeight: "bold" }}>{article.name}</span>&nbsp;
        <FormattedMessageJamezz
          id="AYCE.popups.max-rounds.rule"
          values={{
            roundsMaximum,
          }}
        />
        <p>
          {roundsItemHasBeenOrdered === 0 ? (
            <FormattedMessageJamezz id="AYCE.popups.current-zero" />
          ) : (
            <FormattedMessageJamezz
              id="AYCE.popups.current-nonzero"
              values={{
                count: roundsItemHasBeenOrdered,
              }}
            />
          )}
        </p>
        <p>
          <FormattedMessageJamezz id="AYCE.popups.are-you-sure" />
        </p>
      </DialogContent>
      <DialogActions sx={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
        <Button onClick={onCancel} variant="contained">
          <FormattedMessageJamezz id="Cancel" />
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="success"
          data-cy="arrangement-rule-notice-confirmation-btn"
        >
          <FormattedMessageJamezz id="Ok" />
        </Button>
      </DialogActions>
    </Dialog>
  );
}
